import { theme } from "@meiden-connect/ui";
import { useEffect } from "react";
import { CanvasView } from "../features/canvas/canvas-view";

interface Props {
  readonly canvasId: string;
}

export function CanvasPage({ canvasId }: Props): JSX.Element {
  // TOP のテーマ設定に関わらず、キャンバス編集画面はライトモード固定で表示する。
  useEffect(() => {
    theme.setPreference("light");
  }, []);

  return <CanvasView canvasId={canvasId} />;
}
